import { render } from "./newset.vue?vue&type=template&id=a027e5ea"
import script from "./newset.vue?vue&type=script&lang=js"
export * from "./newset.vue?vue&type=script&lang=js"

import "./newset.vue?vue&type=style&index=0&id=a027e5ea&lang=less"
script.render = render

export default script